import React from 'react';
export function EditorialMethodBox() {
  return <section className="py-16 px-4 bg-white pt-[15px] pb-[15px]" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        
      </div>
    </section>;
}